// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"Messages_cardBody__5lP5F","count":"Messages_count__1-QBc","search":"Messages_search__td6iZ"};